import {
  Text,
  Wrap,
} from '@chakra-ui/react';
import {
  useCrashDistributionStreetCategories,
} from '@src/modules/performance/context/reports-api-hooks';

import TornadoBarChart from '@src/modules/performance/components/charts/TornadoBarChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'DSI Distribution (ONF Street Categories)',
  content: [
    {
      title: 'Length vs no. deaths and serious injuries (ONF Street Categories)',
      description:
  <Text fontSize="inherit" mb={2}>
    The distributed network length of ONF Street Categories and the proportion of deaths and serious injuries (DSI) in those categories for the past ten financial years, in descending order of ONF Street Category. Road Efficiency Group Te Ringa Maimoa has calculated this result.
  </Text>,
      source: <Text fontSize="inherit" as="span">Sourced from the ONF classifications and crash information in AWM.</Text>,
    },
  ],
};
function RoadSafetyCrashDistributionStreetCategories() {
  const { data: crashDistributionOnf, isLoading: isLoadingOnf } = useCrashDistributionStreetCategories();
  const isLoading = isLoadingOnf;

  // ONF Crash Distribution Chart
  const crashDistributionOnfData = [
    {
      name: 'Length %',
      type: 'bar',
      data: crashDistributionOnf?.map((item) => ({
        x: item.category_desc,
        y: item.perc_total_length > 0.0015 ? item.perc_total_length * -100 : 0,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'DSI %',
      type: 'bar',
      data: crashDistributionOnf?.map((item) => ({
        x: item.category_desc,
        y: item.perc_total_dsi > 0.0015 ? item.perc_total_dsi * 100 : 0,
      })),
      color: CHART_COLOURS.red,
    },
  ];

  return (
    <ReportSection
      title="DSI Distribution (ONF Street Categories)"
      informationSource={informationSource}
      lockYear={crashDistributionOnf?.[0]?.LockYear}
      isLoading={isLoading || !crashDistributionOnf}
    >
      <Wrap>
        <TornadoBarChart
          title="Length vs no. deaths and serious injuries"
          categories={[...new Set(crashDistributionOnf?.map((item) => item.category_desc))]}
          series={crashDistributionOnfData}
          suffix="%"
          dataLabelFormatter={(val) => {
            if (val === 0) {
              return '';
            }
            const labelFormatted = val > 0 ? `${val.toFixed(0)}%` : `${Math.abs(val).toFixed(0)}%`;
            return labelFormatted;
          }}
        />
      </Wrap>
    </ReportSection>
  );
}

export default RoadSafetyCrashDistributionStreetCategories;
